import Measurer from './Measurer';
import { update } from 'Emitter';
import { MEASUREMENT } from 'StateEvents';

export default class MediaMeasurer extends Measurer {
  constructor() {
    super();
    this.playbackEventMap = ['impression', 'p_25', 'p_50', 'p_75', 'p_100'];
  }

  onUpdate(nextState = {}, prevState = {}, changes = {}) {
    super.onUpdate(nextState, prevState, changes);

    if(changes.media && changes.media.duration) {
      this.quartileLen = nextState.media.duration / 4;
    }

    if(this.canMeasurePlayback(nextState)) {
      if(this.playbackStarted(nextState)) {
        this.queueRequests(nextState.configuration.Events.impression, MEASUREMENT.IMPRESSION);
        this.queueRequests(nextState.configuration.Events.p_0, MEASUREMENT.VIDEO_START);
      }

      if(this.firstQuartileCrossed(nextState)) {
        this.queueRequests(nextState.configuration.Events.p_25, MEASUREMENT.FIRST_QUARTILE);
      }

      if(this.midpointCrossed(nextState)) {
        this.queueRequests(nextState.configuration.Events.p_50, MEASUREMENT.MIDPOINT);
      }

      if(this.thirdQuartileCrossed(nextState)) {
        this.queueRequests(nextState.configuration.Events.p_75, MEASUREMENT.THIRD_QUARTILE);
      }

      if(this.videoCompleteCrossed(nextState)) {
        this.queueRequests(nextState.configuration.Events.p_100, MEASUREMENT.VIDEO_COMPLETE);
      }

      if(this.videoViewCrossed(nextState)) {
        this.queueRequests(nextState.configuration.Events.view, MEASUREMENT.VIDEO_VIEW);
      }

      if(this.skipEnabled(nextState)) {
        update(MEASUREMENT.SKIP_ENABLED, '');
      }

      if(this.paused(changes, nextState)) {
        this.queueRequests(nextState.configuration.Events.pause, MEASUREMENT.PAUSE);
      }

      if(this.resumed(changes, nextState)) {
        this.queueRequests(nextState.configuration.Events.resume, MEASUREMENT.RESUME);
      }

      if(this.muted(changes, nextState)) {
        this.queueRequests(nextState.configuration.Events.mute, MEASUREMENT.MUTE);
      }

      if(this.unmuted(changes, nextState, prevState)) {
        this.queueRequests(nextState.configuration.Events.unmute, MEASUREMENT.UNMUTE);
      }
    }
  }

  canMeasurePlayback(state = {}) {
    return state.media && state.media.duration > -2 && !state.media.stopped;
  }

  playbackStarted(nextState = {}) {
    return nextState.media && nextState.media.current_time >= 0 && !(nextState.measurement.impression || nextState.measurement.p_0);
  }

  firstQuartileCrossed(nextState = {}) {
    return this.thresholdCrossed(nextState.media, nextState.measurement, 1);
  }

  midpointCrossed(nextState = {}) {
    return this.thresholdCrossed(nextState.media, nextState.measurement, 2);
  }

  thirdQuartileCrossed(nextState = {}) {
    return this.thresholdCrossed(nextState.media, nextState.measurement, 3);
  }

  videoCompleteCrossed(nextState = {}) {
    return this.thresholdCrossed(nextState.media, nextState.measurement, 4);
  }

  videoViewCrossed({ media = {}, configuration = {}, measurement = {} }) {
    return (
      !measurement.view && (
        media.current_time >= configuration.UI.viewAt ||
        (
          media.duration < configuration.UI.viewAt &&
          (
            media.current_time >= media.duration ||
            media.complete
          )
        )
      )
    );
  }

  skipEnabled({ media = {}, configuration = {} }) {
    return configuration.UI.skip && !media.canSkip && media.current_time >= configuration.UI.skipAt;
  }

  paused(changes = {}, state = {}) {
    return changes.media.paused && state.media.paused;
  }

  resumed(changes = {}, state = {}) {
    return changes.media.paused && !state.media.paused;
  }

  muted(changes = {}, state = {}) {
    return changes.media.volume && state.media.volume === 0;
  }

  unmuted(changes = {}, state = {}, prevState = {}) {
    return changes.media.volume && state.media.volume > 0 && prevState.media.volume === 0;
  }

  thresholdCrossed(mediaState = {}, measurementState = {}, quartileNum = {}) {
    return mediaState && (
      (
        mediaState.complete ||
        mediaState.current_time >= (quartileNum * this.quartileLen)
      ) && 
      !this.eventAlreadyRecorded(measurementState, quartileNum)
    );
  }

  eventAlreadyRecorded(measurement = {}, quartile) {
    const eventCode = this.playbackEventMap[quartile];
    return measurement[eventCode];
  }
}


// WEBPACK FOOTER //
// ./src/Services/Measurement/MediaMeasurer.js